import { 
    useState,
    useEffect
} from "react";

import { useDispatch } from "react-redux";

import { Button } from "react-bootstrap";

import { 
    updateKey,
    deleteKey
} from "./store/generalRegSlice";

import "./App.css";

export default function GeneralRegistryRow(props) {
    const dispatch = useDispatch();

    const [rowKey, setRowKey] = useState("");
    const [rowValue, setRowValue] = useState("");

    const onTextChange = (e, txtField) => {
        const val = e.target.value;

        let reg = {
            keyIndex: props.keyIndex,
            key: rowKey,
            value: rowValue
        };

        if (txtField === "KEY") {
            reg = {
                ...reg,
                key: val
            };

            setRowKey(val);
        } else if (txtField === "VALUE") {
            reg = {
                ...reg,
                value: val
            };

            setRowValue(val);
        }

        dispatch(updateKey(reg));
    };

    const onDelete = () => {
        dispatch(deleteKey(props.keyIndex));
    };

    useEffect(() => {
        const {
            key,
            value
        } = props.initialData;

        setRowKey(key);
        setRowValue(value);
    }, []);

    return (
        <tr className="tbody-row">
            <td className="tbody-cell"><input type="text" value={ rowKey } onChange={(e) => { onTextChange(e, "KEY") }} /></td>
            <td className="tbody-cell"><input type="text" value={ rowValue } onChange={(e) => { onTextChange(e, "VALUE") }} /></td>
            <td className="tbody-cell tbody-cell-centered">
                <Button variant="danger" onClick={ onDelete }><img src="img/remove_circle_white_36dp.svg" /></Button>
            </td>
        </tr>
    );
}